function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import classnames from 'classnames';
import { attachPropertiesToComponent as attach } from 'antd-mobile/es/utils/attach-properties-to-component';
import ReactDOM from 'react-dom';
const Dialog = /*#__PURE__*/memo(({
  show = false,
  className = '',
  dialogWrapClassName = '',
  title = '',
  children,
  cancelText = '取消',
  closeOnMaskClick,
  onCancel = () => void 0,
  okText = '确定',
  onOk = () => void 0,
  hideFooter
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames('cc-dialog', className),
  style: {
    display: show ? 'flex' : 'none'
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "dialog-mask",
  onClick: closeOnMaskClick ? onCancel : undefined
}), /*#__PURE__*/React.createElement("div", {
  className: `dialog-wrap ${dialogWrapClassName}`
}, title ? /*#__PURE__*/React.createElement("div", {
  className: "dialog-wrap-title"
}, title) : null, /*#__PURE__*/React.createElement("div", {
  className: "dialog-wrap-content"
}, children), hideFooter ? null : /*#__PURE__*/React.createElement("div", {
  className: "dialog-bottom-btn"
}, cancelText !== false ? /*#__PURE__*/React.createElement("div", {
  className: "dialog-wrap-btn",
  onClick: onCancel
}, /*#__PURE__*/React.createElement("span", {
  className: "cancel txt"
}, cancelText)) : null, /*#__PURE__*/React.createElement("div", {
  className: "divider"
}), /*#__PURE__*/React.createElement("div", {
  className: "dialog-wrap-btn",
  onClick: onOk
}, /*#__PURE__*/React.createElement("span", {
  className: "ok txt"
}, okText))))));
Dialog.displayName = 'cc-dialog';
let instances = [];
const show = options => {
  let el = document.createElement('div');
  document.body.appendChild(el);
  const fireOk = () => {
    Promise.resolve(options.onOk?.()).then(() => {
      close();
    });
  };
  const fireCancel = () => {
    Promise.resolve(options.onCancel?.()).then(() => {
      close();
    });
  };
  ReactDOM.render( /*#__PURE__*/React.createElement(Dialog, _extends({}, options, {
    show: true,
    onOk: fireOk,
    onCancel: fireCancel
  }), options.content), el);
  const close = () => {
    if (!el) return;
    ReactDOM.unmountComponentAtNode(el);
    document.body.removeChild(el);
    instances = instances.filter(f => f !== close);
    el = undefined;
  };
  instances.push(close);
  return close;
};
const closeAll = () => {
  instances.forEach(fn => fn());
  instances = [];
};
export default attach(Dialog, {
  show,
  closeAll
});